import type {
  AccommodationClass,
  AccommodationClassRelation,
} from "../../../../../__generated__/gql/graphql";

// 施設料金（サウナ・温泉・ドッグラン・愛犬同伴）が免除されている理由。
// 免除の有無は各 description の additionalFee が担い、こちらは金額 0 のときに出す文言を決める
export type FacilityFeeWaiver =
  | { reason: "None" }
  | { reason: "Own" }
  | { reason: "LowerClass"; accommodationClass: string };

export type WaivedFacilityFee = Exclude<FacilityFeeWaiver, { reason: "None" }>;

export const NO_FACILITY_FEE_WAIVER: FacilityFeeWaiver = { reason: "None" };

export function resolveFacilityFeeWaiver(accommodation: {
  isOwned: boolean;
  accommodationClass?: AccommodationClass | null;
  classRelation?: AccommodationClassRelation | null;
}): FacilityFeeWaiver {
  if (accommodation.isOwned) {
    return { reason: "Own" };
  }
  const accommodationClass = accommodation.accommodationClass ?? null;
  if (accommodation.classRelation === "Lower" && accommodationClass !== null) {
    return { reason: "LowerClass", accommodationClass };
  }
  return NO_FACILITY_FEE_WAIVER;
}

// 免除になるのはオーナー系と Stay Gift from Owners だけで、どちらも ja 専用ルートからしか予約できないので翻訳しない
export function facilityWaivedFee(waiver: WaivedFacilityFee): string {
  switch (waiver.reason) {
    case "Own":
      return "自己所有物件のため追加料金はかかりません。";
    case "LowerClass":
      return `この施設は ${waiver.accommodationClass} クラスのため、追加料金はかかりません。`;
  }
}

// 愛犬同伴はチェックボックスのラベルに続けて出すので括弧で括る
export function facilityWaivedFeeInParentheses(
  waiver: WaivedFacilityFee,
): string {
  switch (waiver.reason) {
    case "Own":
      return "（自己所有物件のため追加料金はかかりません）";
    case "LowerClass":
      return `（この施設は ${waiver.accommodationClass} クラスのため、追加料金はかかりません）`;
  }
}

// 2027年度改定を跨ぐ滞在で、改定後の泊だけ下位クラス免除になるときの文言。
// 改定日はオーナー系で 2027/4/1 固定なのでハードコードする。移行期間が終わったら削除する
export function facilityLowerClassNoAdditionalFeeOnStraddling(
  accommodationClass: string,
): string {
  return `この施設は ${accommodationClass} クラスのため、2027/4/1以降の宿泊から追加料金はかかりません。`;
}
